import { userService } from "../api/user-auth";

const state = {
  jobs: [],
  new_job: null,
};

const getters = {
  // eslint-disable-next-line no-unused-vars
  jobs: (state, getters) => {
    return state.jobs;
  },
};

const actions = {
  loadJobs({ commit }, jobs) {
    commit("loadJobs", jobs);
  },
  getJobs({ dispatch, commit }) {
    userService.getJson("job/list").then(
      response => {
        if (response.ok) {
          commit("loadJobs", response.data);
        } else {
          commit("clear");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiSaveJob({ dispatch, commit }, job) {
    userService.put("job/" + job.id, job).then(
      response => {
        if (response.ok) {
          commit("updateJob", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiCreateJob({ dispatch, commit }, job) {
    userService.post("job/" + job.id, job).then(
      response => {
        if (response.ok) {
          commit("addJob", response.data);
          dispatch("schedule/addAvailableJob", response.data, { root: true });
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  addJob({ commit }, job) {
    commit("addJob", job);
  },
};

const mutations = {
  addJob(state, job) {
    state.jobs.push(job);
    state.new_job = job;
  },
  updateJob(state, job) {
    var index = state.jobs.findIndex(v => v.id == job.id);
    state.jobs[index] = job;
  },
  loadJobs(state, data) {
    state.jobs = data;
  },
  clear(state) {
    state.jobs = [];
  },
};

export const jobs = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
